import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import BreadcrumbHeading from '../../components/global/BreadcrumbHeading';
import { Table, message, Modal, Icon, Popconfirm, Divider, Tag } from 'antd';
import CelaneseAPI from './../../services';
import config, { utils } from './../../config';
import { getCompaniesData } from '../../actions/index';
import './ManageMessages.css';
import ManageMessagesModal from '../../components/ManageMessagesModal';
import Translation from '../../Translation';

/**
 * Class for ManageMessages.
 *
 * @class ManageMessages
 * @extends {React.Component}
 */
class ManageMessages extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            isModalVisible: false,
            isLongMessageModalVisible: false,
            rows: [],
            apiData: [],
            messagesList: [],
            longMessageText: ''
        }
        this.stringSort = (a, b) => {
            if (a < b) { return -1; }
            if (a > b) { return 1; }
            return 0;
        }
        this.dateString = (a, b) => {
            if (new Date(a).getTime() < new Date(b).getTime()) { return -1; }
            if (new Date(a).getTime() > new Date(b).getTime()) { return 1; }
            return 0;
        }
        this.columns = [{
            title: <Translation labelName="manage_messages_tbl_hdr_created_date" defaultText="Created Date"/>,
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 100,
            render: (val)=> {
               var dt = new Date(val)
                    .toLocaleString('en-us', {year: 'numeric', month: '2-digit', day: '2-digit'})
                    .replace(/(\d+)\/(\d+)\/(\d+)/, '$1-$2-$3');
                return <span>{dt}</span>;
            },
            sorter: (a, b) => this.dateString(a['createdAt'], b['createdAt']),
            onFilter: (value, record) => record['createdAt'].toString().toLowerCase().includes(value.toLowerCase()),
            defaultSortOrder: 'descend'
        }, {
            title: <Translation labelName="manage_messages_tbl_hdr_short_description" defaultText="Short Description"/>,
            dataIndex: 'subject',
            key: 'subject',
            align: 'left',
            width: 200,
            sorter: (a, b) => this.stringSort(a['subject'], b['subject']),
            onFilter: (value, record) => record['subject'].toString().toLowerCase().includes(value.toLowerCase()),
        }, {
            title: <Translation labelName="manage_messages_tbl_hdr_long_description" defaultText="Long Description "/>,
            dataIndex: 'text',
            key: 'text',
            align: 'left',
            render: (val)=> {
                val = val.length > 100 ? val.substr(0, 97)+'...' : val;
                return <span>{val}</span>;
            },
            width: 200,
            sorter: (a, b) => this.stringSort(a['text'], b['text']),
            onFilter: (value, record) => record['text'].toString().toLowerCase().includes(value.toLowerCase()),
        }, {
            title: <Translation labelName="manage_messages_tbl_hdr_company" defaultText="Companies "/>,
            dataIndex: 'companies',
            key: 'companies',
            align: 'left',
            width: 200,
            render: (companies, row) => {
                var isGlobalScope = row.scopeType === 'GLOBAL';
                var tagArr = [];
                if (isGlobalScope) {
                    return <Tag key={row.id} className="comp-global"><Translation labelName="lbl_global" defaultText="Global"/></Tag>;
                }

                companies.forEach((company) => {
                    tagArr.push(<Tag key={company}>{company}</Tag>);
                })

                return <div>{tagArr}</div>;
                 
            },
            sorter: (a, b) => this.stringSort(a['companies'], b['companies']),
            onFilter: (value, record) => record['companies'].toString().toLowerCase().includes(value.toLowerCase()),
        }, {
            title: <Translation labelName="lbl_action" defaultText="Action"/>,
            key: 'action',
            width: 100,
            nocustomfilter: true,
            render: (rec) => (
                <span>
                    <Popconfirm title={<Translation labelName="msg_are_sure_want_dlt_msg" defaultText="Are you sure, do you want delete this message?"/>} placement="topRight" icon={<Icon type="question-circle-o" style={{ color: 'red' }} />} onConfirm={(e) => this.confirmDeleteAction(e, rec)} onCancel={this.cancelAction} okText={<Translation labelName="lbl_yes" defaultText="Yes"/>} cancelText={<Translation labelName="lbl_no" defaultText="No"/>}>
                        <a className="table-links" href="#"><Translation labelName="btn_delete" defaultText="Delete"/></a>
                    </Popconfirm>
                    <Divider type="vertical" />
                    <a className="table-links" href="#" onClick={(e) => this.showMessagePreview(e, rec)}><Translation labelName="lbl_preview" defaultText="Preview"/></a>
                </span>
            ),
        }];
    }

    componentWillMount() {
        this.setState({
            loading: true
        });
        getCompaniesData().then((res) => {
            this.setState({
                apiData: res && res.data ? res.data : []
            });
        }).catch(() => { });
        this.getMessagesList();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.companiesData) {
            this.setState({
                apiData: nextProps.companiesData
            });
        }
    }

    /**
     * success function shows a success message when message is created successfully
     * @param {string} msg custom message to be shown
     * @memberof ManageMessages
     */
    success = (msg) => {
        message.success(msg, 2);
    }

    /**
     * error function shows a error message
     * @memberof ManageMessages
     */
    error = () => {
        message.error(utils.getTranslationText('msg_some_issue', 'There was some issue.'), 2);
    }

    cancelAction = () => {
    }

    /**
     * showMessagePreview function shows a preview content wrapper
     * @param {event} e event is passed
     * @param {object} rec manage message row record is passed
     * @memberof ManageMessages
     */
    showMessagePreview = (e, rec) => {
        e.preventDefault();
        const quickPreviewWrapper = document.querySelector('.quick-preview-message');
        const manageMessagesTable = document.querySelector('.cmp-manage-messages__table-wrapper');
        if (rec.id && quickPreviewWrapper) {
            if (quickPreviewWrapper.offsetHeight) {
                manageMessagesTable.style['height'] = (manageMessagesTable.offsetHeight + quickPreviewWrapper.offsetHeight) + 'px';
            }
            quickPreviewWrapper.querySelector('.quick-preview-message-content').innerHTML = rec.subject + (rec.text && rec.text.length ? ` <a href="#" data-long-message-id= ${ rec.id } class="quick-preview-message-readmore" id="showLargeDescription">${utils.getTranslationText('link_read_more','Read More')}</a>` : '');
            quickPreviewWrapper.classList.remove('displayNone');
            document.querySelector('.main').style['padding-top'] = document.querySelector('.celanese-header').offsetHeight + 'px';
            manageMessagesTable.style['height'] = (manageMessagesTable.offsetHeight - quickPreviewWrapper.offsetHeight) + 'px';
            this.showLongMessageModal();
        }
    }

    /**
     * showLongMessageModal function is for showing long message modal
     * @memberof ManageMessages
     */
    showLongMessageModal = () => {
        const self = this;
        document.getElementById('showLargeDescription').addEventListener('click', (e) => {
            e.preventDefault();
            const messageId = e && e.target ? e.target.getAttribute('data-long-message-id') : null;
            if (messageId) {
                let index = 0;
                const longTextRecord = self.state.messagesList.filter((val, i) => {
                    if (val.id === messageId) {
                        index = i;
                    }
                    return true;
                });
                this.setState({
                    isLongMessageModalVisible: true,
                    longMessageText: longTextRecord.length ? longTextRecord[index].text : ''
                });
            }
        }, false);
    }

    /**
     * confirmDeleteAction function deletes the message created by the admin
     * @param {*} e here e is an event passed
     * @param {object} rec here rec refers to the record of the message being deleted
     * @memberof ManageMessages
     */
    confirmDeleteAction = (e, rec) => {
        e.preventDefault();
        if (rec.id) {
            this.setState({
                loading: true
            });
            CelaneseAPI.delete(config.API.manageMessagesById.replace(':id', rec.id)).then(res => {
                if (!res.error) {
                    this.setState({
                        loading: false
                    });
                    this.success(utils.getTranslationText('msg_message_dlt_success', 'Message deleted Successfully'));
                    this.getMessagesList();
                }
            }).catch(() => {
                this.error(utils.getTranslationText('msg_error_occured_dlt_message', 'Error occured while deleting the Message'));
            });
        }
    }

    /**
     * showManageMessageModal function is for showing a modal which is for creating messages
     * @memberof ManageMessages
     */
    showManageMessageModal = () => {
        this.setState({
            isModalVisible: true
        });
    }

    /**
     * hideManageMessageModal function is for showing a modal which is for creating messages
     * @memberof ManageMessages
     */
    hideManageMessageModal = () => {
        this.setState({
            isModalVisible: false
        });
    }

    /**
     * hideLongMessageModal function is for hiding a modal which is for creating messages
     * @memberof ManageMessages
     */
    hideLongMessageModal = () => {
        this.setState({
            isLongMessageModalVisible: false
        });
    }

    /**
     * getMessagesList function is for getting list of all messages which are entered by the admin
     * @memberof ManageMessages
     */
    getMessagesList = () => {
        CelaneseAPI.get(config.API.manageMessages).then(resp => {
            this.setState({
                messagesList: resp && resp.data ? resp.data : [],
                loading: false,
                rows: resp && resp.data ? resp.data : []
            });
        });
    }

    onCreateMessageSuccess = () => {
        this.setState({
            isModalVisible: false
        });
        this.getMessagesList();
    }

    render() {
        return (
            <Fragment>
                <div className="cmp-manage-messages__header">
                    <BreadcrumbHeading heading={<Translation labelName="title_admin_manage_messages" defaultText="Manage Messages"/>} />
                    <div className="cmp-manage-messages__header-links">
                        <button
                            type="button"
                            onClick={this.showManageMessageModal}
                            className="btn btn-default create-message-link"><Translation labelName="btn_create_message" defaultText="Create Message"/>
                        </button>
                    </div>
                </div>
                <div className="cmp-manage-messages">
                    <div className="cmp-manage-messages__table-wrapper">
                        <Table
                            dataSource={this.state.rows}
                            columns={this.columns}
                            rowKey={Math.random}
                            bordered
                            loading={this.state.loading}
                            pagination={false}
                            scroll={{ y: 'calc(100vh - 230px)' }}
                            size="middle" />
                    </div>
                </div>
                <Modal visible={this.state.isLongMessageModalVisible}
                    title={<Translation labelName="title_whats_new" defaultText="What's New"/>}
                    footer={null}
                    width={700}
                    centered
                    onCancel={() => this.hideLongMessageModal()}
                    className="long-message__modal"
                >
                    {this.state.longMessageText}
                </Modal>
                <ManageMessagesModal companiesData={this.state.apiData} isModalVisible={this.state.isModalVisible} onCreateMessageSuccess={this.onCreateMessageSuccess} loading={this.state.loading} hideManageMessageModal={this.hideManageMessageModal}></ManageMessagesModal>
            </Fragment>
        );
    }
}

const mapStateToProps = ({ loggedUserState }) => ({
    prefData: loggedUserState.prefData
});

const mapDispatchToProps = dispatch => ({
    getCompaniesData: (data) => dispatch(getCompaniesData(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(ManageMessages);

ManageMessages.propTypes = {
    prefData: PropTypes.object,
    companiesData: PropTypes.any,
    getCompaniesData: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/containers/ManageMessages/index.js